import { HStack, Icon, Text, Badge } from '@chakra-ui/react';
import { CheckCircleIcon, WarningIcon } from '@chakra-ui/icons';
import React from 'react';

interface Plan {
  date: string;
  recurring_active: boolean;
  subscription_status: "active" | "past_due" | "canceled" | "incomplete" | "unpaid"
}

const SubscriptionStatusDisplay = (plan: Plan) => {
  const statusColors = {
    active: 'green',
    past_due: 'orange',
    canceled: 'red',
    incomplete: 'yellow',
    unpaid: 'gray',
  };

  const badgeColor = statusColors[plan.subscription_status] || 'blue';

  let formattedDate = '';
  if (plan?.date) {
    const dateObj = plan?.date
    formattedDate = dateObj.substring(0, 10);
  }

  return (
    <HStack spacing={3}>
      <Icon 
        as={plan?.recurring_active ? CheckCircleIcon : WarningIcon} 
        color={plan?.recurring_active ? "green.500" : "red.500"} 
      />
      <Text fontWeight="semibold">
        {plan?.recurring_active ? "Pagamento Recorrente Ativo" : "Pagamento Recorrente Inativo"}
      </Text>
      <Badge colorScheme={badgeColor} variant="subtle">
        {plan?.subscription_status ? plan.subscription_status.toUpperCase() : "SEM STATUS"}
      </Badge>
      {formattedDate && (
        <Text fontSize="sm" color="gray.600">
          {formattedDate}
        </Text>
      )}
    </HStack>
  );
};

export default SubscriptionStatusDisplay;
